"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _types = require('web/screens/Directory/types');
var _useSearchQuery = require('shared/hooks/useSearchQuery');

var _Chips = require('web/components/Chips'); var _Chips2 = _interopRequireDefault(_Chips);
var _List = require('web/screens/App/List');
var _SearchBar = require('./SearchBar'); var _SearchBar2 = _interopRequireDefault(_SearchBar);
var _Users = require('./Users'); var _Users2 = _interopRequireDefault(_Users);
var _Patients = require('./Patients'); var _Patients2 = _interopRequireDefault(_Patients);
var _Teams = require('./Teams'); var _Teams2 = _interopRequireDefault(_Teams);







// The Directory's tabs as the inbox's chips (Directory redesign, #1173), here
// and above the patient table.
 const directoryTabOptions = [
  { tab: _types.DirectoryTab.COWORKERS, label: "Coworkers" },
  { tab: _types.DirectoryTab.TEAMS, label: "Teams" },
  { tab: _types.DirectoryTab.PATIENTS, label: "Patients" },
]; exports.directoryTabOptions = directoryTabOptions

const List = ({ selectedTab, onSelectTab, orgKey }) => {
  const [searchQuery, setSearchQuery] = _useSearchQuery.useSearchQuery.call(void 0, )
  _react.useEffect.call(void 0, () => setSearchQuery(''), [selectedTab, setSearchQuery])
  const onClearSearch = _react.useCallback.call(void 0, () => setSearchQuery(''), [setSearchQuery])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      /* The chips sit right under the header, where the patient table's head
        * has them too, so they don't move between tabs (D-107); the search
        * comes after them. */
      , _react2.default.createElement('div', { className: "inbox-tabs inbox-tabs--even" , role: "group", 'aria-label': "Show", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
        , _react2.default.createElement(_Chips2.default, {
          pills: exports.directoryTabOptions,
          activeTab: selectedTab,
          onSelectTab: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
        )
      )
      , _react2.default.createElement(_SearchBar2.default, {
        value: searchQuery,
        onChange: setSearchQuery,
        selectedTab: selectedTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      )
      , _react2.default.createElement(_List.ListItemsWrapper, { className: "inbox-list-items directory-list--items-list" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        ,  selectedTab === _types.DirectoryTab.COWORKERS && (
          _react2.default.createElement(_Users2.default, { orgKey: orgKey, searchQuery: searchQuery, onClearSearch: onClearSearch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
        )
        ,  selectedTab === _types.DirectoryTab.PATIENTS && (
          _react2.default.createElement(_Patients2.default, { orgKey: orgKey, searchQuery: searchQuery, onClearSearch: onClearSearch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
        )
        ,  selectedTab === _types.DirectoryTab.TEAMS && (
          _react2.default.createElement(_Teams2.default, { orgKey: orgKey, searchQuery: searchQuery, onClearSearch: onClearSearch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} )
        )
      )
    )
  )
}

exports. default = List
